import { VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CustomButton, Layout, MessageWithIcon } from "@lubbezposrednio-frontend/commons";

interface RegisterFailedViewProps {}

export const RegisterFailedView: React.FC<RegisterFailedViewProps> = ({}) => {
  useEffect(() => {
    document.title = "Błąd potwierdzenia rejestracji";
  }, []);

  return (
    <Layout>
      <VStack spacing={0} flex={1} py={{ base: 0, sm: "135px" }} maxW="100vw">
        <MessageWithIcon
          image="/ICON_REGISTER_FAILED.svg"
          title="Nieprawidłowy link"
          message="Link do aktywacji konta jest nieprawidłowy, przeterminowany, lub był wcześniej użyty."
          bottomElement={
            <Link to="/" tabIndex={-1}>
              <CustomButton
                text="Strona główna"
                backgroundColor="accent"
                mb="-20px"
                display={{ base: "flex", md: "none" }}
                w="200px"
              />
            </Link>
          }
          isError
        />
        <Link to="/" tabIndex={-1}>
          <CustomButton
            text="Strona główna"
            backgroundColor="accent"
            my="50px"
            display={{ base: "none", md: "flex" }}
          />
        </Link>
      </VStack>
    </Layout>
  );
};
